import { AlignJustify, LogOut, User } from "lucide-react";
import { useState } from "react";
import { logoutUser } from "@/auth/authSlice";
import { useDispatch } from "react-redux";
import { TranslatedText } from "@/components/common/text";
import { protectedRoutes } from "@/routing";
import { Link } from "react-router";
import { ClickOutside } from "@/components/common/other/ClickOutside";
import { cn } from "@/utils/css";
import { useIsWebUser } from "@/auth/roles";

export const NavDropdown = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dispatch = useDispatch();
    const isWebUser = useIsWebUser();

    const handleClick = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const handleLogout = () => {
        setDropdownOpen(false);
        dispatch(logoutUser());
    };
    const handleClose = () => {
        setDropdownOpen(false);
    };

    return (
        <ClickOutside onClick={handleClose}>
            <div className="relative lg:w-[195px] flex justify-end">
                <div
                    className="flex items-center bg-cm-p-surface-container rounded-[70px] w-[44px] h-[44px] relative justify-center"
                    onClick={handleClick}
                >
                    <div className="rounded-full">
                        <div className="bg-cm-p-accent-100 text-cm-p-text-primary w-9 h-9 rounded-full flex items-center justify-center">
                            <User />
                        </div>
                    </div>
                </div>
                <div
                    className={cn(
                        "z-dropdown absolute right-0 top-11 mt-2 w-32 bg-cm-p-surface-container rounded-lg overflow-hidden transition-all duration-300 drop-shadow-[0_4px_4px_rgba(0,0,0,0.15)]",
                        {
                            "max-h-40 border border-cm-p-outline": dropdownOpen,
                            "max-h-0": !dropdownOpen,
                        },
                    )}
                >
                    <ul className="py-2">
                        {isWebUser ? (
                            <li className="text-cm-p-text-primary">
                                <Link
                                    className="p-2 w-full text-center flex gap-2 text-cm-p-text-primary items-center justify-center"
                                    to={protectedRoutes[3].path}
                                    onClick={handleClose}
                                >
                                    <TranslatedText>View profile</TranslatedText>
                                </Link>
                            </li>
                        ) : null}
                        <li className="text-cm-p-text-primary">
                            <button
                                className="p-2 w-full text-center flex gap-2 text-cm-p-on-container-red items-center justify-center"
                                onClick={handleLogout}
                            >
                                <LogOut />
                                <TranslatedText>Sign out</TranslatedText>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </ClickOutside>
    );
};
